/**
 * This app's own list of `web-*` route paths, relative to the site origin and called through
 * `useApplication().axiosInstance`.
 *
 * *Legacy: don't copy.* A new call takes its URL and types from `@ryerson/common.service-contracts`
 * (`*Api.<Route>.getUrl()`, as `components/Login/EasyQuoteHelpers/EasyQuoteGuestForm.tsx` does
 * for `QuoteApi.PostPublicQuoteSession`), per web-architecture ADR-0024 and ADR-0043 §2. Existing
 * uses stay until that call is next changed.
 *
 * Each path must match the route the API serves; nothing checks it at build time.
 */
export enum APIUrl {
	/**
	 * Users API: starts a forgot- or set-password flow for a user name
	 * (`components/ForgotPassword/ForgotPassword.tsx` → `onResetPasswordClick`).
	 */
	VERIFY_USER = "/v1/users/v1/public/forgot-password/send-token",
	/**
	 * Users API: checks the reset code
	 * (`components/ForgotPassword/VerifyToken/VerifyTokenRoot.tsx`).
	 */
	VALIDATE_TOKEN = "/v1/users/v1/public/forgot-password/validate-token",
	/**
	 * Users API: sets the new password
	 * (`components/ForgotPassword/ResetPassword/ResetPasswordRoot.tsx`).
	 */
	SET_PASSWORD = "/v1/users/v1/public/forgot-password/set-password",
	/**
	 * Users API: checks the registration e-mail code
	 * (`components/Register/VerifyToken/RegisterVerifyTokenRoot.tsx`).
	 */
	REGISTER_VALIDATE_TOKEN = "/v1/users/v1/public/registration/validate-token",
	/**
	 * Users API: first registration step, with the reCAPTCHA token
	 * (`components/Register/RegisterForm.tsx`).
	 */
	REGISTER_SEND_TOKEN = "/v1/users/v1/public/registration/send-token",
	/**
	 * Users API: creates the web user
	 * (`components/Register/CreateAccount/CreateAccountRoot.tsx`).
	 */
	CREATE_USER_ACCOUNT = "/v1/users/v1/public/user/create",
	/** Items API product search. No caller in this repo. */
	SEARCH_PRODUCTS = "/v1/items/v1/public/items",
	/** Prices API pricing. No caller in this repo. */
	PRICING_SERVICE = "/v1/prices/v1/public/pricing",
	/**
	 * Users API, signed-in: saves the new user's address
	 * (`components/Register/UserAddress/UserAddress.tsx`, rendered on `/register/created`). No
	 * registration step navigates to that page: account creation goes to `/register/thank-you`.
	 * The member name's spelling is referenced in `UserAddress.tsx`.
	 */
	ADDRESS_COMFIRMATION = "/v1/users/v1/protected/addresses",
	/** Shopping API add-to-cart. No caller in this repo. */
	ADD_TO_CART = "/v1/shopping/v1/protected/shopping-cart/items",
	/** Payments API: creates the Stock List PayPal order (`components/StockList/Purchase.tsx`). */
	STOCK_LIST_ORDER = "/v1/payments/v1/public/paypal/order/stock-list",
	/**
	 * Payments API: confirms the PayPal payment when the buyer returns
	 * (`pages/stock-list/complete/index.tsx`).
	 */
	STOCK_LIST_ORDER_ACKNOWLEDGEMENT = "/v1/payments/v1/public/paypal/order/stock-list/acknowledgement",
	/** Items API delivery times. No caller in this repo. */
	DELIVERY_TIMES = "/v1/items/v1/public/delivery-times",
}
